site.news = {
	init: function () {
		var $entries = $('.entries', '#news');
		if (!$entries) return false;

		var $grid = $('.entries', '#news').imagesLoaded( function() {
			// init Masonry after all images have loaded
			$grid.masonry({
				itemSelector: '.entry',
				gutter: 0,
				isAnimated: true
			});
		});

		$('a', '.loadMore').on('click touchStart', function (e) {
			e.preventDefault();
			$(this).addClass('loading');

			site.news.loadNews({
				url: $entries.data('url'),
				page: $entries.data('page'),
				total: $entries.data('total'),
			});
		});
	},

	loadNews: function (options) {
		$.ajax({
			url: options.url + parseInt(options.page),
			dataType: 'json',
			success: function (r) {
				$r = $(r);
				$('a', '.loadMore').removeClass('loading');
				var $entries = $('.entries', '#news');
				$entries.append($r).masonry('appended', $r, true);
				$entries.data('page', parseInt(options.page) + 1);

				var $grid = $('.entries', '#news').imagesLoaded( function() {
					// init Masonry after all images have loaded
					$grid.masonry({
						itemSelector: '.entry',
						gutter: 0,
						isAnimated: true
					});
				});

				if ($('.entry', $entries).length == options.total) {
					$('.loadMore').hide();
				}
			},

			error: function (e) {
				console.log(e);
			}
		});
	}
};

site.inits.push('site.news.init()');
